import React from "react";
import _ from "lodash";
import { Button, Image } from "semantic-ui-react";

export default class ImageButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hovered: false,
            loading: false,
        };
    }

    setHover = () => this.setState({ hovered: true });
    removeHover = () => this.setState({ hovered: false });

    render() {
        let thisImage = _.find(this.props.imageLibrary, {
            id: this.props.image,
        });
        let hasImage = this.props.image.indexOf("default") === -1;
        let baseStyle = {
            padding: hasImage ? 0 : undefined,
            borderRadius: "5px",
        };
        let componentStyles = {
            default: {
                ...baseStyle,
                width: "100%",
                fontSize: "1.25em",
                marginBottom: "5px",
                background: this.state.hovered
                    ? this.props.colors.primaryVariation
                    : this.props.secondary
                    ? this.props.colors.secondary
                    : this.props.colors.primary,
                color: this.props.secondary
                    ? this.props.colors.secondaryText
                    : this.props.colors.primaryText,
            },
            grid: {
                ...baseStyle,
                width: "48%",
                height: "6em",
                display: "inline-block",
                verticalAlign: "middle",
                fontSize: "1.25em",
                marginBottom: "5px",
                background: this.state.hovered
                    ? this.props.colors.primaryVariation
                    : this.props.secondary
                    ? this.props.colors.secondary
                    : this.props.colors.primary,
                color: this.props.secondary
                    ? this.props.colors.secondaryText
                    : this.props.colors.primaryText,
            },
        };

        return (
            <Button
                as="a"
                href={this.props.link}
                target="_blank"
                rel="noreferrer noopener"
                loading={this.state.loading}
                style={{
                    ...componentStyles[this.props.layout],
                    position: "relative",
                }}
                onMouseEnter={this.setHover}
                onMouseLeave={this.removeHover}
                onClick={this.handleClick}
            >
                {hasImage && (
                    <Image
                        src={thisImage.image}
                        alt={this.props.name}
                        style={{
                            borderRadius: "5px",
                            width: "25%",
                            float: "left",
                        }}
                    />
                )}
                <div
                    style={
                        hasImage
                            ? {
                                  padding: "12px",
                                  textAlign: "left",
                                  position: "absolute",
                                  top: "50%",
                                  left: "calc(25% + 10px)",
                                  transform: "translateY(-50%)",
                              }
                            : {}
                    }
                >
                    {this.props.name}
                </div>
            </Button>
        );
    }
}
